import { render } from "./showBrokersComponent.vue?vue&type=template&id=36c19a70"
import script from "./showBrokersComponent.vue?vue&type=script&lang=js"
export * from "./showBrokersComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__